var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "176px",
    viewBox: "0 0 78 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3614A499-52FA-4CF9-B1B6-751BB4BC6423") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 92.5,
    cy: 92.5,
    r: 92.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GloepidOne",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-details",
    transform: "translate(-9.000000, -2477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30-Copy",
    transform: "translate(-92.000000, 2468.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 20,
    opacity: 0,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    mask: "url(#mask-2)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58.000000, -78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-5",
    transform: "translate(145.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Duplicate-control",
    points: "0 0 145 0 145 145 0 145"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 132.659574,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 132.659574,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 132.659574,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 132.659574,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 132.659574,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 132.659574,
    r: 2.05673759
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-7",
    transform: "translate(145.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Duplicate-control",
    points: "0 0 145 0 145 145 0 145"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 2.05673759,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 16.4539007,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 30.8510638,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 45.248227,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 60.6737589,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 74.0425532,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 16.4539007,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 2.05673759,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 16.4539007,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 30.8510638,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 45.248227,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 60.6737589,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 74.0425532,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 30.8510638,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 2.05673759,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 16.4539007,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 30.8510638,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 45.248227,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 60.6737589,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 74.0425532,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 45.248227,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 2.05673759,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 16.4539007,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 30.8510638,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 45.248227,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 60.6737589,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 74.0425532,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 60.6737589,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 2.05673759,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 16.4539007,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 30.8510638,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 45.248227,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 60.6737589,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 74.0425532,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 74.0425532,
    cy: 118.262411,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 2.05673759,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 16.4539007,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 30.8510638,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 45.248227,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 60.6737589,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 74.0425532,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 89.4680851,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 102.836879,
    r: 2.05673759
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 89.4680851,
    cy: 118.262411,
    r: 2.05673759
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDots);
export default __webpack_public_path__ + "static/media/circle-dots.cae14337f01979b7b5ee9f3035b8c033.svg";
export { ForwardRef as ReactComponent };